<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="600"
  >
  <ng-template #modalTitle>
    Etikett hinzufügen
  </ng-template>

  <ng-template #modalContent>
    <nz-select
      class="full-width"
      nzPlaceHolder="Etikettenart auswählen"
      [(ngModel)]="selectedArticleLabelType"
      [nzDisabled]="typeLocked">
      @for (x of articleLabelTypes | keyvalue; track x) {
        <nz-option
          [nzValue]="x.key"
          [nzLabel]="articleLabelTypesDisplayNames[x.value]"
        ></nz-option>
      }
      <nz-option
        [nzValue]="ownBrandSmallRoundType"
        nzLabel="rund 45x45"
      ></nz-option>
    </nz-select>

    @if (article) {
      <nz-select
        class="full-width"
        nzPlaceHolder="Varianten auswählen"
        nzMode="multiple"
        [(ngModel)]="selectedArticleVariantIds"
        [nzDisabled]="variantLocked"
        style="margin-top: 16px;"
        >
        @for (x of articleVariants; track x.id) {
          <nz-option
            [nzValue]="x.id"
            [nzLabel]="x.name"
          ></nz-option>
        }
      </nz-select>
    }
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
    <button
      nz-button
      nzType="primary"
      [disabled]="!selectedArticleLabelType || selectedArticleVariantIds.length === 0"
      [nzLoading]="isLoading"
      (click)="confirmSelectedArticleLabelType()"
    >Weiter</button>
  </ng-template>
</nz-modal>

<app-add-edit-round-label-modal
  #addEditRoundLabelModalComponent
  (refresh)="refresh.emit(); closeModal();"
  />
